export const BRANDS_METERS_TYPES = {
  LOAD_BRANDS_METERS_NEW: "LOAD_BRANDS_METERS_NEW",
  SET_BRANDS_METERS_NEW: "SET_BRANDS_METERS_NEW",
  CLEAR_BRAND_MODEL: "CLEAR_BRAND_MODEL",
  MODELS_BY_BRANDS_METERS: "MODELS_BY_BRANDS_METERS",
  ERROR_BRANDS_METERS: "ERROR_BRANDS_METERS",
  NEW_BRAND_MODEL: "NEW_BRAND_MODEL",
  UPSERT_BRAND_MODEL: "UPSERT_BRAND_MODEL",
  EDIT_BRAND_MODEL: "EDIT_BRAND_MODEL"
};
